/**
 * True when value looks like a scheduler record from the lead scheduler API.
 *
 * @param {unknown} value
 */
export function isSchedulerRecord(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  return Boolean(value.scheduler_id ?? value.id);
}

/**
 * Normalize scheduler list API payloads into a flat array of scheduler records.
 *
 * Known shapes:
 * - `[{ scheduler_id, ... }]`
 * - `{ schedulers: [...] }`
 * - `{ data: { schedulers: [...] } }`
 * - `{ data: [...] }`
 *
 * Avoids `Object.values()` on wrapper objects — empty `{ schedulers: [] }` must not
 * count as "1 automation configured".
 *
 * @param {unknown} payload
 * @returns {Array<object>}
 */
export function normalizeSchedulerList(payload) {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload.filter(isSchedulerRecord);
  }

  if (typeof payload !== 'object') {
    return [];
  }

  if (Array.isArray(payload.schedulers)) {
    return payload.schedulers.filter(isSchedulerRecord);
  }

  if (payload.data && typeof payload.data === 'object') {
    if (Array.isArray(payload.data.schedulers)) {
      return payload.data.schedulers.filter(isSchedulerRecord);
    }
    if (Array.isArray(payload.data)) {
      return payload.data.filter(isSchedulerRecord);
    }
  }

  return [];
}

/**
 * @param {unknown} payload
 */
export function countConfiguredAutomations(payload) {
  return normalizeSchedulerList(payload).length;
}
